import { createAsyncThunk } from '@reduxjs/toolkit';
import campaignBriefService from '../../services/campaign_brief_api_service';

export const fetchCampaignBriefChatData = createAsyncThunk(
  'campaignBrief/fetchChatData',
  async (params, { rejectWithValue }) => {
    try {
      const data = await campaignBriefService.fetchCampaignBriefChatData(params);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch chat data');
    }
  }
);

export const pushCampaignToConfluence = createAsyncThunk(
  'campaignBrief/pushCampaignToConfluence',
  async (params, { rejectWithValue }) => {
    try {
      const data = await campaignBriefService.pushCampaignToConfluence(params);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch chat data');
    }
  }
);